import { useEffect, useState } from 'react';

/**
 * Display-only signal: true while Explore's drawer (ListSheet) is mounted on the
 * property screen. The login Random Outcomes drawer waits on it before handing
 * off. It carries no casino/insight data and does not touch any data path.
 */
let exploreReady = false;
const listeners = new Set<() => void>();

export function setExploreReady(next: boolean): void {
  if (exploreReady === next) return;
  exploreReady = next;
  listeners.forEach((l) => l());
}

export function getExploreReady(): boolean {
  return exploreReady;
}

export function subscribeExploreReady(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useExploreReady(): boolean {
  const [ready, setReady] = useState(getExploreReady);
  useEffect(() => {
    setReady(getExploreReady());
    return subscribeExploreReady(() => setReady(getExploreReady()));
  }, []);
  return ready;
}
